"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StructuralCommitPrototype = exports.StructuralClass = exports.StreamTypeId = exports.SinkTypeId = exports.EffectTypeId = exports.EffectPrototype = exports.CommitPrototype = exports.Class = exports.ChannelTypeId = void 0;
var internal = _interopRequireWildcard(require("./internal/effectable.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @since 2.0.0
 * @category type ids
 */
const EffectTypeId = exports.EffectTypeId = internal.EffectTypeId;
/**
 * @since 2.0.0
 * @category type ids
 */
const StreamTypeId = exports.StreamTypeId = internal.StreamTypeId;
/**
 * @since 2.0.0
 * @category type ids
 */
const SinkTypeId = exports.SinkTypeId = internal.SinkTypeId;
/**
 * @since 2.0.0
 * @category type ids
 */
const ChannelTypeId = exports.ChannelTypeId = internal.ChannelTypeId;
/**
 * @since 2.0.0
 * @category prototypes
 */
const EffectPrototype = exports.EffectPrototype = internal.EffectPrototype;
/**
 * @since 2.0.0
 * @category prototypes
 */
const CommitPrototype = exports.CommitPrototype = internal.CommitPrototype;
/**
 * @since 2.0.0
 * @category prototypes
 */
const StructuralCommitPrototype = exports.StructuralCommitPrototype = internal.StructuralCommitPrototype;
const Base = internal.Base;
const StructuralBase = internal.StructuralBase;
/**
 * @since 2.0.0
 * @category constructors
 */
class Class extends Base {}
/**
 * @since 2.0.0
 * @category constructors
 */
exports.Class = Class;
class StructuralClass extends StructuralBase {}
exports.StructuralClass = StructuralClass;
//# sourceMappingURL=Effectable.js.map